import"react";import r from"./deepEquals.esm.js";function t(t,e,a){var o=t.props,p=t.state;return!r(o,e)||!r(p,a)}export{t as default};
